export default [ '$stateProvider', $stateProvider => {
  $stateProvider
    .state('404', {
      url: '',
      component: 'httpError',
      auth: false,
      resolve: {
        statusCode: () => 404,
        error: () => 'Not found'
      }
    })
    .state('403', {
      url: '',
      component: 'httpError',
      auth: false,
      resolve: {
        statusCode: () => 403,
        error: () => 'Forbidden'
      }
    })
    .state('401', {
      url: '',
      component: 'httpError',
      resolve: {
        statusCode: () => 401,
        error: () => 'Unauthorized'
      }
    })
    .state('500', {
      url: '',
      component: 'httpError',
      auth: false,
      resolve: {
        statusCode: () => 500,
        error: () => 'Internal error'
      }
    });
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/error/error.routes.js